module.exports = __webpack_public_path__ + "static/media/Group1675.5929a9d3.svg";